import React from 'react';
import { ContentDivider, Popover } from '@milanote/roma';
import BoardLinkSearchBar from './BoardLinkSearchBar';
import { useBoardLinkContent } from './useBoardLinkContent';
import BoardLinkListContent from './BoardLinkListContent';
import { BoardLinkSearchItem } from './boardLinkTypes';

type BoardLinkPopupContentProps = {
    onSelect: (item: BoardLinkSearchItem) => boolean;
    onPasteBoardLink: (text: string) => boolean;
};

const BoardLinkPopupContent: React.FC<BoardLinkPopupContentProps> = ({ onSelect, onPasteBoardLink }) => {
    const { searchQuery, setSearchQuery, ...listContentProps } = useBoardLinkContent();

    return (
        <div className="BoardLinkPopupContent flex min-h-0 flex-col">
            <BoardLinkSearchBar
                className="mb-2"
                value={searchQuery ?? ''}
                onChange={setSearchQuery}
                onPasteBoardLink={onPasteBoardLink}
                autoFocus={true}
                size="sm"
            />
            <ContentDivider type="single-line" />
            <Popover.Body className="BoardLinkList min-h-0 flex-1 overflow-y-auto py-1.5">
                <BoardLinkListContent onSelect={onSelect} size="sm" {...listContentProps} />
            </Popover.Body>
        </div>
    );
};

export default BoardLinkPopupContent;
